if (!String.prototype.includes) {
    // eslint-disable-next-line
    String.prototype.includes = function(search, start) {
      // eslint-disable-next-line
      'use strict';
      if (typeof start !== 'number') {
        start = 0;
      }
      
      if (start + search.length > this.length) {
        return false;
      } else {
        return this.indexOf(search, start) !== -1;
      }
    };
  }



// WEBPACK FOOTER //
// ./src/utils/polyfills/String.includes.js